/* eslint-disable */
"use client";

import { useEffect, useState } from "react";
import { PaginatedReportListSection } from "@/components/sections/PaginatedReportListSection";
import { curationService } from "@/services/curation.service";
import { CurationSectionItem } from "@/types/report";

export function CurationSections() {
  const [sections, setSections] = useState<CurationSectionItem[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCurationSections = async () => {
      try {
        const result = await curationService.getCurationSections();
        if (result.code !== "SUCCESS") {
          console.error('Failed to fetch curation sections');
          return;
        }
        const data = result;
        // To-Be 형식 처리
        if (data.code === "SUCCESS" && data.data?.sections) {
          setSections(data.data.sections);
        } else {
          // 배열로 직접 반환되는 경우도 처리
          setSections(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        console.error('Error fetching curation sections:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCurationSections();
  }, []);

  if (loading) {
    return (
      <div className="w-[1560px]">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-200 rounded w-1/3 mb-6"></div>
          <div className="grid grid-cols-4 gap-6">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="space-y-4">
                <div className="h-48 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded"></div>
                <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {sections.map((sec, idx) => {
        const title = String(sec.title);
        const hasBlue = /<blue>[\s\S]*?<\/blue>/i.test(title);
        // console.log(title, hasBlue);
        return (
          <div className="w-full max-w-[1560px]" key={idx}>
            <PaginatedReportListSection
              key={idx}
              // blueTitle={hasBlue ? "" : title}
              // blackTitle=""
              titleHtml={hasBlue ? title : title}
              columns={4}
              items={sec.reports as any}
              viewAllHref={`/reportlist?topic=${sec.id}`}
              topicId={sec.id}
              useCurationSection={true}
            />
          </div>
        );
      })}
    </>
  );
}
